// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"a6b5f3b7","36":"91ada27e","341":"ba676f1e","731":"5c19ed5a","791":"991695a3","840":"fa0308fa"}[chunkId] + ".chunk.css";
};